import { firebase } from "@firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/analytics";
import "firebase/messaging";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyCpWeoGzDrwoJjnsjBnDu-vVUt6LfGHyxk",
    authDomain: "cecdbfirebase.firebaseapp.com",
    databaseURL: "https://cecdbfirebase.firebaseio.com",
    projectId: "cecdbfirebase",
    storageBucket: "cecdbfirebase.appspot.com",
    messagingSenderId: "497574235952",
    appId: "1:497574235952:web:1504a70b103c4441e802f5",
    measurementId: "G-T2KLVM7GYD"
};
firebase.initializeApp(firebaseConfig);
if (typeof window !== "undefined") {
  import("firebase/performance").then(() => firebase.performance());
}
export default firebase;
